const mixinCalculateExtraHourWeek = {
  methods: {
    processData(data) {
      const result = {};

      data.forEach((item) => {
        const weekSave = item.week_save;
        const workerId = item.worker.id;
        const extraDayHours = parseFloat(item.extra_day_hours) || 0;

        if (!result[weekSave]) {
          result[weekSave] = {};
        }

        if (!result[weekSave][workerId]) {
          result[weekSave][workerId] = {
            total_extra_day_hours: 0,
            worker_name: `${item.worker.first_name} ${item.worker.last_name}`,
            worker_code: item.worker.code,
          };
        }

        result[weekSave][workerId].total_extra_day_hours += extraDayHours;
      });

      return Object.entries(result).map(([weekSave, workers]) => ({
        week_save: weekSave,
        workers: Object.entries(workers).map(([workerId, data]) => ({
          worker_id: parseInt(workerId),
          ...data,
        })),
      }));
    },

    handleCellStyle({ row }) {
      const isHeaderRow = 'farm_id' in row && 'worker_id' in row && 'date' in row;
    
      if (isHeaderRow) {
        const isDuplicate = this.tableData
          .filter((item) => item.id !== row.id)
          .some((item) => {
            const condition = `${item.farm_id} ${item.worker_id} ${item.date}`;
            const toEvaluate = `${row.farm_id} ${row.worker_id} ${row.date}`;
            return condition === toEvaluate;
          });
    
        const extraWeekHours = this.extraHoursByWeek
          .filter((item) => item.week_save === row.week_save)
          .reduce((acc, item) => acc.concat(item.workers), [])
          .filter((item) => item.worker_id === row.worker_id)
          .reduce((acc, item) => acc + item.total_extra_day_hours, 0);
    
        if (
          Number(row.exceeds_daily_limit) > 12 
          || isDuplicate
          || row.extra_day_hours && Number(row.extra_day_hours) > 4
          || Number(extraWeekHours) > 12
        ) {
          return 'background-color: #fde6e4;';
        }
      } else {
        const data = this.tableDataDetails.filter((item) => item.id !== row.id);
        const isDuplicate = data.some((item) => {
          const condition = `${item.quantity} ${item.activity_id} ${
            item.number_hours
          } ${item.lot_id ? item.lot_id : ''}`;
          const toEvaluate = `${row.quantity} ${row.activity_id} ${
            row.number_hours
          } ${row.lot_id ? row.lot_id : ''}`;
    
          return condition === toEvaluate;
        });
    
        if (!row.subtotal || isDuplicate) {
          return 'background-color: #fde6e4;';
        }
      }
    
      return '';
    }
  },
};

export default mixinCalculateExtraHourWeek;
